import { render, staticRenderFns } from "./cuotiJlu.vue?vue&type=template&id=a27f22d2&scoped=true"
import script from "./cuotiJlu.vue?vue&type=script&lang=js"
export * from "./cuotiJlu.vue?vue&type=script&lang=js"
import style0 from "./cuotiJlu.vue?vue&type=style&index=0&id=a27f22d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27f22d2",
  null
  
)

export default component.exports